import React from 'react'
import { FaHome, FaAngleDown, FaAngleUp,FaTable, FaEnvelope, 
    FaShoppingCart, FaCalculator, FaThList, FaBookDead, FaUserPlus } from 'react-icons/fa'

export default {
    HomeIcon: <FaHome size={16} color={`#666`} />,
    DownIcon: <FaAngleDown size={16} color={`#666`} />,
    UpIcon: <FaAngleUp size={16} color={`#666`} />,
    TableIcon: <FaTable size={16} color={`#666`} />,
    EnvelopeIcon: <FaEnvelope size={16} color={`#666`}/>,
    ShoppingIcon: <FaShoppingCart size={16} color={`#666`}/>,
    CalculatorIcon: <FaCalculator size={16} color={`#666`}/>,
    FileList: <FaThList size={16} color={`#666`}/>,
    BookReaderIcon: <FaBookDead size={16} color={`#666`}/>,
    NewUserIcon: <FaUserPlus size={16} color={`#666`}/>
}